export default __webpack_public_path__ + "static/107-38e5e18785c63ea5325678737af79432.jpg";